import { render, staticRenderFns } from "./holiday.vue?vue&type=template&id=2d45a06d&scoped=true"
import script from "./holiday.vue?vue&type=script&lang=js"
export * from "./holiday.vue?vue&type=script&lang=js"
import style0 from "./holiday.vue?vue&type=style&index=0&id=2d45a06d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45a06d",
  null
  
)

export default component.exports